<div mat-dialog-content style="padding-bottom: 20px;text-align: -webkit-center;">
    <span style="flex: 1 1 auto;">
      <mat-label>{{message}}</mat-label>
    </span>
</div>
